import { createApp } from 'vue'
import App from './App.vue'
import router from "./route";

import '@/assets/scss/main.css'
import '@/assets/scss/sticky.css'
import 'remixicon/fonts/remixicon.css';

const app = createApp(App);
app.use(router);
app.mount("#app");